var AmbienteEnum = {
    DEVELOPMENT: 'DEV',
    PRODUCTION: 'PROD' 
}

export default AmbienteEnum;